/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_OpenInputs */

const en_dr_pick_open = /** @type {(inputs: Dr_Pick_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Design Rooms →`)
};

const id_dr_pick_open = /** @type {(inputs: Dr_Pick_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka Design Room →`)
};

/**
* | output |
* | --- |
* | "Open Design Rooms →" |
*
* @param {Dr_Pick_OpenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_open = /** @type {((inputs?: Dr_Pick_OpenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_OpenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_open(inputs)
	return en_dr_pick_open(inputs)
});